import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from './usePublicFeatureFlags';
export function useIsStandaloneRoutesEnabled() {
  const {
    featureFlags,
    loading
  } = usePublicFeatureFlags();
  return {
    isEnabled: featureFlags.includes(FeatureFlags.PUBLIC_APP_STANDALONE_ROUTES),
    loading
  };
}